enum AdminServiceGridSortColumn {
    Site,
    Name,
    Speciality,
    Duration,
    Price,
    Type,
    Details,
    Settings
}

export { AdminServiceGridSortColumn };
